import * as React from "react";
import { InstantCollapsible } from "sb-resp-ui";
import { CardType, MarketTemplate } from "../../../../data";
import { SecondaryHeading, HeadingTitle } from "../../components";
import { RenderMarketNames } from "../RenderComponents/RenderMarketNames";
import { ContainerQuery } from "react-container-query";
import { marketColumnsDisplay } from "../../../../constants";
import { Params } from "react-container-query/lib/interfaces";

export class SecondaryHeadingContent extends React.PureComponent<{
    id : string,
    name: string,
    eventsCount: string,
    shouldExpand: boolean,
    marketNames: Array<Array<string>>,
    marketTemplates: MarketTemplate[],
    cardType: CardType
}, {} > {

    renderSubheading(params?: Params) {
        return <SecondaryHeading
                key={`subheading-${this.props.id}`}
                cardType={this.props.cardType}
            >
                <HeadingTitle name={this.props.name} eventsCount={this.props.eventsCount} />
                {this.props.marketNames.length
                    ? <RenderMarketNames marketNames={this.props.marketNames} marketTemplates={this.props.marketTemplates} queryParams={params} />
                    : ""
                }
            </SecondaryHeading>
    }

    render() {
        return (
            <InstantCollapsible key={`collapse-subheading-${this.props.id}`} initiallyExpanded={this.props.shouldExpand} trigger={
                this.props.cardType === CardType.Multiview ?
                    <ContainerQuery query={marketColumnsDisplay}>
                        {(params) => this.renderSubheading(params)}
                    </ContainerQuery>
                    : this.renderSubheading()
            }
                content={
                    <>
                        {this.props.children}
                    </>
                }
            />
        )
    }
}